import { ListItem } from '@mui/material'
import React, { type HTMLAttributes } from 'react'

import { TruncatedTextWithTooltip } from 'components/common/TruncatedTextWithTooltip'
import { KubernetesListItemTags } from 'components/services/create/target-selection/kubernetes/KubernetesListItemTags'

import type { K8sAutocompleteSearchOption } from 'components/services/create/target-selection/kubernetes/types'

/**
 * Render each individual option in the Kubernetes autocomplete dropdown. Displays the option label
 * and any associated tags.
 */
export const KubernetesAutocompleteSearchOption = React.forwardRef<
  HTMLLIElement,
  {
    option: K8sAutocompleteSearchOption
    props: HTMLAttributes<HTMLLIElement>
  }
>(({ option, props, ...rest }, ref) => {
  const { label, tags } = option

  return (
    <ListItem
      {...props}
      {...rest}
      ref={ref}
      sx={(muiTheme) => ({
        columnGap: muiTheme.spacing(2),
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        maxWidth: '100%'
      })}
    >
      <TruncatedTextWithTooltip tooltipProps={{ title: label }} variant="body2">
        {label}
      </TruncatedTextWithTooltip>
      <KubernetesListItemTags tags={tags} />
    </ListItem>
  )
})

KubernetesAutocompleteSearchOption.displayName =
  'KubernetesAutocompleteSearchOption'
